import React from "react";
import { HiDotsVertical } from "react-icons/hi";

const ProgressCard = ({ title, number, icon, dis_number, status, pts, pts_icons }) => {
  return (
    <div className="card">
      <div className="header_area">
        <div className="icon-box">{icon}</div>
        <HiDotsVertical className="icons dot-icon" />
      </div>
      <div className="mt-3">
        <p className="sub-title">{title}</p>
        <h1 className="number mt-2">
          {number} <span className="dis-number">{dis_number}</span>
        </h1>
      </div>
      <div className="mt-3">
        <p className="pts">
          {pts_icons}
          {pts} <span className="status">{status}</span>
        </p>
      </div>
    </div>
  );
};

export default ProgressCard;
